import {
  DegreeDetailV4Data,
  DegreeDetailV4Variant,
  DegreeDetailV4TestResult,
  UseDegreeDetailV4,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "degreeDetailPageV4";

/**
 * Hook for the degree detail v4 experiment.
 * This experiment can return one of two variants:
 * - control: Original design
 * - test: New design with branding color and images
 */
const useDegreeDetailV4: UseDegreeDetailV4 = () => {
  const { isLoading, value } = useMonarchRule<{
    data: DegreeDetailV4Data;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value) {
    return {
      isLoading,
    } as DegreeDetailV4TestResult;
  }

  const variant: DegreeDetailV4Variant = value.data.showRedesign
    ? "test"
    : "control";

  return {
    isLoading: false,
    variant,
    data: {
      showRedesign: value?.data?.showRedesign,
      brandColor: value?.data?.brandColor,
      aboutImage: value?.data?.aboutImage,
      admissionsImage: value?.data?.admissionsImage,
    },
  };
};

export default useDegreeDetailV4;
